import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import { IBriefPricingResponse } from "@shared/lib/types/pricingWorkload";
import { IPricingTracker, IPricingTrackerFacets } from "../types";

export class PricingTrackerService {
  public static async getPricingAnalytics(data: {
    from_to: {
      from: string;
      to: string;
    };
    assignedPricingPocs: string[];
    brandIds: string[];
    briefIds: string[];
  }) {
    return (await api
      .post("analytics/pricing/margin-distribution", {
        json: { ...data },
      })
      .json()) as BackednResponse<IPricingTracker>;
  }

  public static async getPricingAnalyticsFacets(data: {}) {
    return (await api
      .post("analytics/pricing/margin-distribution/facets", {
        json: { ...data },
      })
      .json()) as BackednResponse<IPricingTrackerFacets>;
  }
  public static async downloadPricingAnalytics(data: {
    from_to: {
      from: string;
      to: string;
    };
    assignedPricingPocs: string[];
    brandIds: string[];
    briefIds: string[];
    isCostCheckedByPricing?: boolean;
  }) {
    return (await api
      .post("download/analyticsMarginDistribution", {
        json: { ...data },
      })
      .json()) as BackednResponse<void>;
  }

  public static async updatePricingAnalytics(data: {
    briefInfluencerIds: string[];
  }) {
    return (await api
      .put(`brief/influencer-v2/mark-cost-checked-by-pricing`, {
        json: { ...data },
      })
      .json()) as BackednResponse<void>;
  }
}
